import type { ShipmentsTranslations } from './types'

/**
 * Urdu translations for Shipments domain
 * Comprehensive translations covering all UI text
 */
export const urTranslations: ShipmentsTranslations = {
  // Page/Section level
  title: "شپمنٹس",
  subtitle: "اپنی شپمنٹس کو ٹریک اور منظم کریں",
  overview: "جائزہ",

  // Actions
  addShipment: "شپمنٹ شامل کریں",
  editShipment: "شپمنٹ میں ترمیم کریں",
  deleteShipment: "شپمنٹ حذف کریں",

  // Search and filters
  searchPlaceholder: "شپمنٹس تلاش کریں...",
  noItemsFound: "کوئی شپمنٹ نہیں ملی",
  noItemsDescription: "آپ نے ابھی تک کوئی شپمنٹ شامل نہیں کی۔",
  addFirst: "اپنی پہلی شپمنٹ شامل کریں",
  noShipments: "کوئی شپمنٹ نہیں",
  noShipmentsDescription: "آپ کے موجودہ فلٹرز سے کوئی شپمنٹ میل نہیں کھاتی۔",

  // Status labels
  total: "کل",
  scheduled: "شیڈول شدہ",
  loading: "لوڈنگ",
  inTransit: "راستے میں",
  delivered: "ترسیل شدہ",
  cancelled: "منسوخ",
  activeDeliveries: "فعال ترسیلات",

  // Shipment details
  shipmentDetails: "شپمنٹ کی تفصیلات",
  shipmentNumber: "شپمنٹ نمبر",
  order: "آرڈر",
  quantity: "مقدار",
  productType: "پروڈکٹ کی قسم",
  product: "پروڈکٹ",
  origin: "اصل مقام",
  destination: "منزل",
  status: "حالت",

  // Route info
  routeInfo: "راستے کی معلومات",
  from: "سے",
  to: "تک",
  eta: "متوقع وقت آمد",
  scheduledDate: "شیڈول شدہ تاریخ",

  // Transport
  transport: "نقل و حمل",
  driver: "ڈرائیور",
  truck: "ٹرک",

  // Weighbridge
  weighbridge: "وزنی پل",
  weighbridgeGross: "کل وزن",
  weighbridgeTare: "خالی وزن",
  weighbridgeNet: "خالص وزن",
  weighbridgeTicket: "ٹکٹ نمبر",
  weighbridgeMeasuredAt: "پیمائش کا وقت",
  weighbridgeScale: "ترازو",
  trackingTimeline: "ٹریکنگ ٹائم لائن",

  // Form section
  form: {
    name: "شپمنٹ کا نام",
    namePlaceholder: "شپمنٹ کا نام درج کریں",
    status: "حالت",
    validation: {
      nameRequired: "شپمنٹ کا نام ضروری ہے",
    }
  },

  // Status (compatibility)
  statusLabels: {
    active: "فعال",
    inactive: "غیر فعال",
  },

  // Messages
  messages: {
    createSuccess: "شپمنٹ کامیابی سے بنائی گئی",
    updateSuccess: "شپمنٹ کامیابی سے اپ ڈیٹ ہوئی",
    deleteSuccess: "شپمنٹ کامیابی سے حذف ہوئی",
    deleteConfirm: "کیا آپ واقعی اس شپمنٹ کو حذف کرنا چاہتے ہیں؟",
  },

  // Table headers
  table: {
    name: "نام",
    status: "حالت",
  },

  // Resource assignment
  resourceUpdated: "وسیلہ کامیابی سے اپ ڈیٹ ہوا",
  resourceUpdateFailed: "وسیلہ اپ ڈیٹ کرنے میں ناکامی",
  change: "تبدیل کریں",
  assign: "تفویض کریں",
  validationError: "تصدیق کی غلطی",
  noDriverInfo: "ڈرائیور کی معلومات نہیں",
  waitingForInput: "مکمل ان پٹ کا انتظار ہے...",

  // Simulation
  simulation: {
    title: "آرڈر سمولیشن",
    subtitle: "حقیقی API کالز کے ساتھ آرڈر کی مکمل لائف سائیکل چلائیں",
    orderNumber: "آرڈر نمبر",
    activityLog: "سرگرمی لاگ",
    inputs: "ان پٹس",
    scanIn: "اسکین ان",
    scanOut: "اسکین آؤٹ",
    recordTare: "خالی وزن ریکارڈ",
    recordGross: "کل وزن ریکارڈ",
    pullInvoices: "انوائسز کھینچیں",
    entryGate: "داخلے کا گیٹ",
    exitGate: "خروج کا گیٹ",
    entryFirstWeight: "داخلے کا پہلا وزن (کلوگرام)",
    entrySecondWeight: "داخلے کا دوسرا وزن (کلوگرام)",
    weighbridgeScan: "ویبرج اسکین",
    scanWeighbridge: "اندر اسکین کریں",
    weighbridgeScanComplete: "ویبرج داخلہ اسکین مکمل",
    tareWeight: "خالی وزن (کلوگرام)",
    grossWeight: "کل وزن (کلوگرام)",
    invoiceSync: "انوائس مطابقت",
    waiting: "انتظار...",
    assignResource: "وسیلہ تفویض کریں",
    assign: "تفویض",
    joinQueue: "قطار میں شامل ہوں (کیوسک)",
    joinQueueButton: "قطار میں شامل ہوں",
    resourceAssigned: "وسیلہ تفویض کر دیا گیا",
    queueJoined: "قطار میں شامل · SAP SO بن گئی",
    driverJoinsQueue: "ڈرائیور کیوسک پر قطار میں شامل · SAP سیلز آرڈر یہاں بنتا ہے",
    pullInvoicesDesc: "ڈیلیوری قبولیت کے بعد SAP CPI سے انوائسز کھینچیں",
    licensePlatePlaceholder: "لائسنس پلیٹ",
    driverNamePlaceholder: "ڈرائیور کا نام",
    orderNumberPlaceholder: "ORD-2026-...",
    gateCodeEntryPlaceholder: "GATE-01",
    gateCodeExitPlaceholder: "GATE-02",
    entryComplete: "داخلے کا اسکین مکمل",
    exitComplete: "خروج کا اسکین مکمل",
    qrScan: "QR اسکین",
    licensePlate: "لائسنس پلیٹ",
    qrReader: "QR ریڈر",
    selectQrReader: "QR ریڈر منتخب کریں...",
    noQrReadersFound: "اس زون میں کوئی QR ریڈر نہیں",
    camera: "کیمرہ",
    selectCamera: "کیمرہ منتخب کریں...",
    noCamerasFound: "اس زون میں کوئی کیمرہ نہیں",
    lpInputPlaceholder: "مثلاً: 0012-AAA",
    responseError: "جواب (خطا)",
    responseSuccess: "جواب",
    errors: {
      failedToLoadFactory: "فیکٹری سیاق لوڈ کرنے میں ناکامی",
      failedToLoadLifecycle: "لائف سائیکل لوڈ کرنے میں ناکامی",
      noOrderNumber: "آرڈر نمبر سیٹ نہیں ہے",
      orderIdUnavailable: "آرڈر آئی ڈی دستیاب نہیں — آرڈر دوبارہ لوڈ کریں",
      stepFailed: "قدم کی تکمیل ناکام",
      refreshLifecycleFailed: "مرحلے کی ناکامی کے بعد لائف سائیکل اپ ڈیٹ کرنے میں ناکامی",
    },
  },

  // Shipment card
  noResourceAssigned: "کوئی وسیلہ تفویض نہیں",
  selectResource: "وسیلہ منتخب کریں",
  truckIdentification: "ٹرک کی شناخت",
  driverCredentials: "ڈرائیور کی اسناد",
  selectedLabel: "منتخب",
  plateLettersPlaceholder: "ABC",

  // Top-level convenience keys
  name: "نام",
  namePlaceholder: "شپمنٹ کا نام درج کریں",
  nameRequired: "شپمنٹ کا نام ضروری ہے",
  active: "فعال",
  inactive: "غیر فعال",
  createSuccess: "شپمنٹ کامیابی سے بنائی گئی",
  updateSuccess: "شپمنٹ کامیابی سے اپ ڈیٹ ہوئی",
  deleteSuccess: "شپمنٹ کامیابی سے حذف ہوئی",
  deleteConfirm: "کیا آپ واقعی اس شپمنٹ کو حذف کرنا چاہتے ہیں؟",
}
